/* A silent, inline hero loop with explicit pause, reduced-motion and off-screen handling. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ps18-loop]').forEach(frame => {
      if (frame.dataset.ps18Ready) return;
      const video = frame.querySelector('video');
      const button = frame.querySelector('[data-ps18-toggle]');
      if (!video || !button) return;
      frame.dataset.ps18Ready = 'true';
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let userPaused = false;
      let userPlayed = false;
      let visible = true;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      const syncButton = () => {
        const paused = video.paused;
        button.classList.toggle('is-paused', paused);
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.setAttribute('title', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      };
      const play = () => {
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(syncButton);
      };
      const reconcile = () => {
        if (!visible || document.hidden || userPaused || (motion.matches && !userPlayed)) video.pause();
        else play();
        syncButton();
      };
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; userPlayed = true; play(); }
        else { userPaused = true; video.pause(); }
        syncButton();
      });
      video.addEventListener('play', syncButton);
      video.addEventListener('pause', syncButton);
      video.addEventListener('error', () => { button.hidden = true; });
      button.hidden = false;
      document.addEventListener('visibilitychange', reconcile);
      if (motion.addEventListener) motion.addEventListener('change', () => { userPlayed = false; reconcile(); });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          reconcile();
        }, { threshold: 0.05 });
        observer.observe(frame);
      }
      reconcile();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
